"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainResult = exports.mapError = exports.mapResult = exports.isFailure = exports.isSuccess = exports.failure = exports.success = void 0;
const success = (data) => ({
    success: true,
    data,
});
exports.success = success;
const failure = (error) => ({
    success: false,
    error,
});
exports.failure = failure;
const isSuccess = (result) => result.success;
exports.isSuccess = isSuccess;
const isFailure = (result) => !result.success;
exports.isFailure = isFailure;
// Map function for transforming success values
const mapResult = (result, fn) => {
    if ((0, exports.isSuccess)(result)) {
        return (0, exports.success)(fn(result.data));
    }
    return result;
};
exports.mapResult = mapResult;
// Map error function for transforming error values
const mapError = (result, fn) => {
    if ((0, exports.isFailure)(result)) {
        return (0, exports.failure)(fn(result.error));
    }
    return result;
};
exports.mapError = mapError;
// Chain/flatMap function for sequencing operations
const chainResult = (result, fn) => {
    if ((0, exports.isSuccess)(result)) {
        return fn(result.data);
    }
    return result;
};
exports.chainResult = chainResult;
//# sourceMappingURL=Result.js.map